  document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll(".filter-btn");
    const productGrid = document.querySelector(".mt-6.flex.flex-wrap"); // Select the product container
    const products = document.querySelectorAll(".product-item");

    function updateProductDisplay(filter) {
      let visibleProducts = 0;

      products.forEach(product => {
        if (filter === "all" || product.getAttribute("data-tags").includes(filter)) {
          product.style.display = "block";
          visibleProducts++;
        } else {
          product.style.display = "none";
        }
      });

      // If less than 4 products are visible, center them
      if (visibleProducts > 0 && visibleProducts < 4) {
        productGrid.style.justifyContent = "center";
      } else {
        productGrid.style.justifyContent = ""; // Reset to default
      }
    }

    buttons.forEach(button => {
      button.addEventListener("click", function() {
        buttons.forEach(btn => btn.classList.remove("active"));
        this.classList.add("active");

        const filter = this.getAttribute("data-filter");
        updateProductDisplay(filter);
      });
    });

    // Initial check in case default filter is applied
    updateProductDisplay("all");
  });